import { useCallback, useState } from "react";
import { getProducts } from "../../../components/products/functions";
import { useStableSearch } from "../../hooks/useStableSearch";

const DEFAULT_FILTERS = {
  q: "",
  email: "",
  id: "",
  status: ["QUEUE"],
  delivery: "",
  store: "",
};

export function useProductsSearch(user) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const runSearch = useCallback(async ({ token, filters: activeFilters, isCurrent }) => {
    setLoading(true);
    setError(null);

    const { email, id, q, status, delivery, store } = activeFilters;
    const query = q?.trim() || undefined;
    // Com texto de pesquisa, busca em todos os status (o chip QUEUE escondia resultados).
    const statusParam = query
      ? undefined
      : Array.isArray(status)
        ? status.filter(Boolean).join(",") || undefined
        : status || undefined;
    const data = await getProducts(
      token,
      email,
      id,
      statusParam,
      delivery,
      store,
      undefined,
      query
    );

    if (!isCurrent()) {
      return;
    }

    if (data?.type === "error") {
      setError(data);
      setProducts([]);
    } else if (data?.type === "success") {
      setProducts(Array.isArray(data.data) ? data.data : []);
    } else {
      setProducts(Array.isArray(data) ? data : []);
    }

    setLoading(false);
  }, []);

  const search = useStableSearch(user?.token, filters, runSearch);
  const refresh = useCallback(() => search(), [search]);

  return { products, loading, error, filters, setFilters, search, refresh };
}
